import EventBus from "./event-bus";

export function getProcessList() {
  let list = [
    {
      title:'신청',
    },
    {
      title:'견적',
    },
    {
      title:'픽업',
    },
    {
      title:'운송',
    },
    {
      title:'도착'
    }
  ];
  return list;
}
export function millisToReadable(timestamp) {

  if(timestamp == 0) {
    return "";
  }
  let date = new Date(timestamp);

  //

  let yy = date.getFullYear().toString();

  let mm = (date.getMonth()+1).toString();
  if (mm.length == 1) mm = '0'+mm;

  let dd = date.getDate().toString();
  if (dd.length == 1) dd = '0'+dd;

  let hh = date.getHours().toString();
  if (hh.length == 1) hh = '0'+hh;

  let minute = date.getMinutes().toString();
  if (minute.length == 1) minute = '0'+minute;

  let second = date.getSeconds().toString();
  if (second.length == 1) second = '0'+second;

  // let today = new Date();
  // if(today.getFullYear().toString() === yy) {
  //   return mm+'.'+dd+' '+hh+':'+minute+':'+second;
  // }
  return yy+'.'+mm+'.'+dd+' '+hh+':'+minute+':'+second;

}
export function getDayOfWeek(day) {
  let date = new Date(day);
  return date.getDay();
}
export function getDateString(dayDiff = 0) {
  let date = new Date();

  date.setDate(date.getDate() + dayDiff);

  let yy = date.getFullYear().toString();

  let mm = (date.getMonth()+1).toString();
  if (mm.length == 1) mm = '0'+mm;

  let dd = date.getDate().toString();
  if (dd.length == 1) dd = '0'+dd;

  return yy+'-'+mm+'-'+dd;
}
export function millisToDate(timestamp = 0) {
  let date;
  if(timestamp == 0) {
    date = new Date();
  } else {
    date = new Date(timestamp);
  }
  let yy = date.getFullYear().toString();

  let mm = (date.getMonth()+1).toString();
  if (mm.length == 1) mm = '0'+mm;

  let dd = date.getDate().toString();
  if (dd.length == 1) dd = '0'+dd;

  return yy+'-'+mm+'-'+dd;
}
export function showDialog(message = '', title = '') {
  let params = {
    title:title,
    text:message
  }
  EventBus.$emit("showDialog", params);
}



// WEBPACK FOOTER //
// ./src/api/utils.js